import { usePendingImportPoll } from './usePendingImportPoll';

const PendingImportPoll = () => {
  usePendingImportPoll();
  return null;
};

export default PendingImportPoll;
